/**
 * Site-wide constants used by SEO, structured data, and shared copy.
 *
 * This file intentionally stays conservative. It should describe only the
 * strongest public version of reality that the strategy docs allow.
 */

export const SITE_URL = 'https://avenstudios.com';
export const SITE_NAME = 'Aven Studios';
export const SITE_BRAND = 'AvenBox';
export const SITE_TAGLINE = 'The sovereign control layer for AI';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/hero.png`;
export const DEFAULT_LOCALE = 'en_US';
export const ROADMAP_TARGET = 'Q1 2027';
export const CURRENT_STAGE_NOTE =
    'A real working AI control, privacy, and orchestration prototype, now being shaped into a production-grade product.';

/** Organization profile used for Organization JSON-LD. */
export const ORG = {
    name: SITE_NAME,
    legalName: 'avenstudios s.p.',
    url: SITE_URL,
    logo: `${SITE_URL}/aven-logo.png`,
    email: 'hello@avenstudios.com',
    foundingDate: '2024',
    description:
        'Aven Studios is building AvenBox, a sovereign AI control system centered on privacy, trusted execution, and deliberate routing.',
    address: {
        locality: 'Ljubljana',
        country: 'SI',
    },
    sameAs: [
        // Add real public social profiles here only when they are live.
    ],
};

/** Founders used for Person JSON-LD. */
export const FOUNDERS = [
    {
        name: 'Marko Vodopivec',
        jobTitle: 'Founder',
        image: `${SITE_URL}/marko-vodopivec.jpg`,
        worksFor: SITE_NAME,
    },
];
